import type { HTMLAttributes, ReactNode } from 'react';

export type BoxProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
};

/** Generic box — prefer tokens for spacing via `style` or className. */
export function Box({ className, style, children, ...rest }: BoxProps) {
  return (
    <div className={className} style={style} {...rest}>
      {children}
    </div>
  );
}
